import { useQuery } from "@tanstack/react-query";
import { getWorkRequestApproval } from "../clients/workRequestClient";
import { useWorkScope } from "../components/WorkScopeProvider";
import type { WorkRequestId } from "../lib/workIds";

export function useWorkRequestApprovalQuery(
  workRequestId: WorkRequestId | null,
) {
  const { selectedCustomer, selectedFacility } = useWorkScope();
  return useQuery({
    queryKey: [
      "work-request-approval",
      selectedCustomer?.id,
      selectedFacility?.id,
      workRequestId,
    ],
    queryFn: () => {
      if (workRequestId === null || !selectedCustomer || !selectedFacility) {
        throw new Error(
          "A work request, customer, and facility must be selected.",
        );
      }
      return getWorkRequestApproval(
        workRequestId,
        selectedCustomer.id,
        selectedFacility.id,
      );
    },
    enabled: Boolean(
      workRequestId !== null && selectedCustomer && selectedFacility,
    ),
    meta: { errorMessage: "Failed to load the work request." },
  });
}
